import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { OnChange } from 'react-final-form-listeners';
import { useFormState, useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import QCXFinalNumericIntegerField from '../../../../shared-components/final-numeric-integer-field/QCXFinalNumericIntegerField'; // inteiros




export default function NumeroInteiro({
    metadado, 
    isConsult,
    basePath="",
    ncm=false,
    ...restProps
}) {

    const [label, setLabel] = useState("")
    const [name,  setName] = useState("")
    const [obrigatorio, setObrigatorio] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [listValores, setListValores] = useState([]);
    const [defaultValue, setDefaultValue] = useState('');
    const [tamanhoMaximo, setTamanhoMaximo] = useState(null);
    const form = useForm();
    
    useEffect(() => {
        if (!ncm) {
            setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valor`)
        } else {
            setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`)
        }
        
        setLabel(metadado?.nome);
        setObrigatorio(metadado?.validacao?.obrigatorio || false);
    }, [metadado])
    
    if(!name) {
        return null
    }


    return (
        <Grid item xs={12} sm={6} md={4}>
            <QCXFinalNumericIntegerField
                id={codigo}
                key={codigo}
                name={name}
                label={label}
                scale={7}
                disabled={isConsult}
                allowNegative={false}
                required={obrigatorio}
                {...restProps}
            />
        </Grid>
    )
}
